<p-autoComplete
    [suggestions]="suggestions"
    (onKeyUp)="addressSearched.emit($event)"
    (completeMethod)="fetchAutocompleteSuggestions($event.query)"
    (onSelect)="onPlaceSelected($event)"
    placeholder="Search an address"
    optionLabel="label"
    optionValue="value"
    [(ngModel)]="selectedLocation"
    [placeholder]="placeholder"
    [style]="inputStyle"
    [ngClass]="ngClass"
>
    <ng-template
        let-option
        pTemplate="item"
        class="autocomplete-item"
    >
        <i [class]="option.icon"></i>
        <span>{{ option.label }}</span>
    </ng-template>
</p-autoComplete>